import { useEffect, useState } from "react";
import { ADMIN_REALTIME_BROWSER_EVENT } from "../realtime/adminRealtimeClient";

export default function useAdminRealtimeEvent() {
	const [eventPayload, setEventPayload] = useState(null);

	useEffect(() => {
		const handleRealtime = (event) => {
			const detail =
				event && typeof event === "object" ? event.detail ?? {} : {};
			setEventPayload({
				...detail,
				_eventTs: Date.now(),
			});
		};

		window.addEventListener(ADMIN_REALTIME_BROWSER_EVENT, handleRealtime);

		return () => {
			window.removeEventListener(ADMIN_REALTIME_BROWSER_EVENT, handleRealtime);
		};
	}, []);

	return eventPayload;
}
